import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Stack } from '@components/stack';

import { Box } from 'components/Box';
import { IntegrationField } from 'components/IntegrationField';
import { IntegrationHeader } from 'components/IntegrationHeader';
import { Loading } from 'components/Loading';
import { useStore } from 'models/Provider';

export const SAPOnboarding = observer(({ integration, saving, submit, validator, validating }) => {
  integration.loadForApplication();
  const { t } = useStore();
  return (
    <>
      <IntegrationHeader integration={integration} />
      {integration.state === 'loading' && <Loading />}
      {integration.state !== 'loading' && !integration.triggered && (
        <Box mt="24" inactive={saving}>
          <Stack space={4}>
            {integration.data.map((data, i) => (
              <IntegrationField
                data={data}
                validator={validator}
                refetch={integration.refetchForApplication}
                key={i}
              />
            ))}
          </Stack>
          <Box flex justifyContent="flex-end" mt="20">
            <Button
              style={{ marginLeft: 8 }}
              variant="primary-blue"
              isDisabled={saving || integration.refetching}
              onClick={() => submit(false, true)}
              text={t('application.onboarding.integration.save')}
            />
            <Button
              style={{ marginLeft: 8 }}
              isDisabled={
                saving ||
                integration.refetching ||
                integration.isBlocked ||
                validating ||
                integration.hasErrors()
              }
              onClick={() => submit(false, false)}
              text={t('application.onboarding.integration.submit')}
            />
          </Box>
        </Box>
      )}
      {integration.state !== 'loading' && integration.triggered && (
        <Box border padding="24" mt="24" backgroundColor="white">
          <Stack space={4}>
            {integration.data.map((data, i) => (
              <IntegrationField data={data} validator={validator} key={i} readOnly />
            ))}
          </Stack>
        </Box>
      )}
    </>
  );
});
